import { action, makeObservable, observable, runInAction, computed } from 'mobx';
import isNil from 'lodash/isNil';
import { Message, StoreNode, StoreNodeProps } from '../../store';
import { Nullable } from '../../core';
import { Store } from '../../store/store';
import { WindowState } from '../../components/overlays';
import { notifyError, notifySuccess } from '../../services/notifications';
import { JobModel } from '../../entities';

export type DeleteTrackOpenParams = {
  job: JobModel,
  jobId: string,
  trackId: string
}

export class DeleteTrackState
  extends StoreNode {

  readonly nodeType = 'DeleteTrackState';

  constructor(store: Store, props?: StoreNodeProps) {
    super(store, props);
    makeObservable(this, {
      job: observable,
      isLoading: observable,
      jobId: observable,
      trackId: observable,
      deleteSpeaker: action,
      handleError: action,
      open: action,
      close: action,
      isTrackEmpty: computed,
    });
    this.window.listen(
      this.windowListener);
  }
  job: Nullable<JobModel> = null
  isLoading = false;
  jobId: Nullable<string> = null;
  trackId: Nullable<string> = null;

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        if (this.isLoading)
          return;
        this.close();
        break;
    }
  }
  readonly window = new WindowState(this.store);

  async deleteSpeaker() {
    if (!this.jobId || !this.trackId || !this.job) return;

    this.isLoading = true;
    const [, err] = await this.store.apiService.deleteTrack({
      jobId: this.jobId,
      trackId: this.trackId
    });

    if (err) {
      return this.handleError();
    } else {
      await this.job.fetchDependencies();
    }
    this.close();

    runInAction(() => {
      this.isLoading = false;
      notifySuccess(this, 'Swimlane removed.');
    })
  }

  handleError() {
    this.isLoading = false;
    notifyError(this, 'Could not delete swimlane.');
  }

  open(params: DeleteTrackOpenParams) {
    this.dispatch('Overlays', 'openWindow', { name: 'DeleteTrackPopup' });

    this.job = params.job;
    this.jobId = params.jobId;
    this.trackId = params.trackId;
  }

  close() {
    this.dispatch('Overlays', 'closeWindow');

    this.job = null;
    this.jobId = null;
    this.trackId = null;
  }

  get isTrackEmpty() {
    const count = this.job?.tracks.find(({ id }) => id === this.trackId)?.moments.length;

    return !isNil(count) ? count <= 0 : true;
  }
}